<template>
  <div class="results-page">
    <h2 class="section-title">Rozpis zápasů</h2>
    
    <!-- Season filter -->
    <div class="mb-4">
      <select v-model="selectedSeason" class="form-select" @change="loadData">
        <option value="">Vyberte ročník</option>
        <option v-for="season in seasons" :key="season.id" :value="season.id">
          {{ season.name }}
        </option>
      </select>
      <select v-model="selectedTeam" class="form-select" @change="loadData">
        <option value="">Vyberte tým</option>
        <option v-for="team in teams" :key="team.id" :value="team.id">
          {{ team.name }}
        </option>
      </select>
      <div class="form-check mt-3">
        <input type="checkbox" class="form-check-input" id="showOnlyUpcoming" v-model="showOnlyUpcoming" @change="applyScheduleFilter">
        <label class="form-check-label" for="showOnlyUpcoming">
          Pouze nadcházející zápasy
        </label>
      </div>
    </div>

    <!-- Tabs -->
    <ul class="nav nav-tabs mb-4">
      <li class="nav-item">
        <a class="nav-link" :class="{ active: activeTab === 'schedule' }" @click="activeTab = 'schedule'" href="#">
          Rozpis utkání
        </a>
      </li>
    </ul>


    <!-- Schedule -->
    <div v-if="activeTab === 'schedule'" class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Den</th>
            <th>Datum</th>
            <th>Čas</th>
            <th>Domácí</th>
            <th>vs</th>
            <th>Hosté</th>
            <th>Místo konání</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="match in scheduledMatches" :key="match.id">
            <td>{{ getDayOfWeek(match.match_date) }}</td>
            <td>{{ formatDateOnly(match.match_date) }}</td>
            <td>{{ formatTimeOnly(match.match_date) }}</td>
            <td>{{ getTeamName(match.home_team_id) }}</td>
            <td>vs</td>
            <td>{{ getTeamName(match.away_team_id) }}</td>
            <td>{{ match.venue }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SchedulePage',
  data() {
    return {
      selectedSeason: '',
      seasons: [],
      teams: [],
      matches: [],
      activeTab: 'schedule',
      selectedTeam: '',
      showOnlyUpcoming: false,
      scheduledMatches: []
    }
  },
  methods: {
    async loadSeasons() {
      try {
        const seasonsRes = await axios.get('/api/seasons');
        this.seasons = seasonsRes.data;
        if (this.seasons.length > 0) {
          this.selectedSeason = this.seasons[0].id;
          this.loadData();
        }
      } catch (error) {
        console.error('Error loading seasons:', error);
      }
    },
    async loadTeams() {
      const teamsRes = await axios.get('/api/teams');
      this.teams = teamsRes.data;
    },
    async loadData() {
      if (!this.selectedSeason) return;
      try {
        const params = { season_id: this.selectedSeason };
        if (this.selectedTeam) params.team_id = this.selectedTeam;
        const response = await axios.get('/api/matches', { params });
        this.matches = response.data;
        this.applyScheduleFilter();
      } catch (error) {
        console.error('Error loading data:', error);
      }
    },
    
    applyScheduleFilter() {
      this.scheduledMatches = this.showOnlyUpcoming
        ? this.matches.filter(m => m.status === 'scheduled')
        : [...this.matches];
    },
    getTeamName(teamId) {
      const team = this.teams.find(t => t.id === teamId);
      return team ? team.name : 'Neznámý tým';
    },
    formatDateOnly(date) {
      return new Date(date).toLocaleDateString('cs-CZ');
    },
    formatTimeOnly(date) {
      return new Date(date).toLocaleTimeString('cs-CZ', { 
        hour: '2-digit', 
        minute: '2-digit',
        timeZone: 'UTC'
      });
    },
    getDayOfWeek(date) {
      const days = ['NE', 'PO', 'UT', 'ST', 'ČT', 'PÁ', 'SO'];
      return days[new Date(date).getDay()];
    }
  },
  mounted() {
    this.loadSeasons();
    this.loadTeams();
  }
}
</script>

<style scoped>
.results-page {
  max-width: 1200px;
  margin: 0 auto;
  background: #0a1023;
  color: #e0e6f7;
  min-height: 100vh;
  padding: 2rem 1rem 3rem;
}

.section-title {
  background: linear-gradient(135deg, #1fe0ff, #0a7cff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.15;
  font-size: 1.75rem;
  margin-bottom: 1.5rem;
}

.table {
  background: transparent;
  color: #e0e6f7;
  border-radius: 0.75rem;
  overflow: hidden;
  margin-bottom: 1.5rem;
  border-collapse: separate;
  border-spacing: 0;
}

.table thead th {
  background: rgba(31, 224, 255, 0.06);
  color: #1fe0ff;
  font-weight: 600;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  border: none;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid rgba(31, 224, 255, 0.1);
}

.table-striped tbody tr:nth-of-type(odd) {
  background: rgba(31, 224, 255, 0.02);
}

.table-striped tbody tr:nth-of-type(even) {
  background: transparent;
}

.table td, .table th {
  border: none;
  padding: 0.7rem 1rem;
  vertical-align: middle;
}

.table td {
  border-bottom: 1px solid rgba(31, 224, 255, 0.04);
}

.table tbody tr {
  transition: background 0.2s ease;
}

.table tbody tr:hover {
  background: rgba(31, 224, 255, 0.03);
}

.nav-tabs {
  border-bottom: none;
  gap: 0.5rem;
  padding-bottom: 1rem;
  flex-wrap: wrap;
}

.nav-tabs .nav-link {
  color: #8892b0;
  background: transparent;
  border: 1px solid rgba(31, 224, 255, 0.13);
  border-radius: 999px;
  padding: 0.45rem 1.15rem;
  font-weight: 600;
  font-size: 0.88rem;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  margin-right: 0;
  white-space: nowrap;
}

.nav-tabs .nav-link:hover {
  color: #1fe0ff;
  border-color: rgba(31, 224, 255, 0.3);
  background: rgba(31, 224, 255, 0.05);
}

.nav-tabs .nav-link.active {
  background: linear-gradient(135deg, #1fe0ff, #0a7cff);
  color: #0a1023 !important;
  font-weight: 700;
  border: none;
  box-shadow: 0 4px 20px rgba(31, 224, 255, 0.25);
}

.form-select {
  background: #0a1023;
  color: #e0e6f7;
  border: 1px solid rgba(31, 224, 255, 0.13);
  border-radius: 0.5rem;
  padding: 0.6rem 0.85rem;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  margin-bottom: 1rem;
}

.form-select:focus {
  border-color: #1fe0ff;
  box-shadow: 0 0 0 3px rgba(31, 224, 255, 0.15);
  background: #0a1023;
  color: #e0e6f7;
}

.form-check-label {
  color: #e0e6f7;
}

.form-check-input {
  background-color: #0a1023;
  border-color: rgba(31, 224, 255, 0.2);
}

.form-check-input:checked {
  background-color: #1fe0ff;
  border-color: #1fe0ff;
}

@media (max-width: 768px) {
  .results-page {
    padding: 1rem 0.5rem 2rem;
  }
}
</style> 